(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('Profile', Profile);

    Profile.$inject = ['$resource'];

    function Profile ($resource) {
        var resourceUrl =  'api/profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'myProfile': {
                method: 'GET',
                url: 'api/profiles/myprofile',
                isArray: false
            },
            'countProfilesForOrganisation': {
                method: 'GET',
                url: 'api/profiles/countProfilesForOrganisation?organisationId=:organisationId',
                isArray: false
            },
            'countAxenteeversForOrganisation': {
                method: 'GET',
                url: 'api/profiles/countAxenteeversForOrganisation?organisationId=:organisationId',
                isArray: false
            },
            'update': { method:'PUT' },
            'init': { method:'POST', url: 'api/profiles/init', },
            'delete': {
                method: 'DELETE',
                url: 'api/profiles/:id',
            },
            'category': {
                method: 'GET',
                isArray: true,
                url: '/api/profiles/organisation/category'
            },
            'search': {
                method: 'GET',
                url: 'api/profiles/search/:query',
                isArray: true
            },
            'getPicture': {
                method: 'GET',
                url: 'api/profiles/:id/picture',
                isArray: false,
                transformResponse: function (data) { return  data.toString() }
            },
            'myContributions': {
                method: 'GET',
                url: 'api/profiles/mycontributions',
                isArray: true
            },
            'aConnecter': {
                method: 'GET',
                url: 'api/profiles/aconnecter',
                isArray: true
            },
            'check': {
                method: 'POST',
                url: 'api/profiles/check',
                isArray: false
            },
            'requestDelete': {
                method: 'POST',
                url: 'api/profiles/requestDelete',
                isArray: false
            },
        });
    }
})();
